import { useEffect, type ReactNode } from 'react';
import { useAuthStore } from '@store/authStore';
import { useNotificationStore } from '@store/notificationStore';
import { notificationService } from '@services/notificationService';
import { realtime } from '@services/realtime';
import type { Notification } from '@/types';

export function NotificationHydrator({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setItems = useNotificationStore((s) => s.setItems);
  const add = useNotificationStore((s) => s.add);

  useEffect(() => {
    if (!isAuthenticated) return;
    notificationService
      .list()
      .then((res) => setItems(res.items))
      .catch(() => undefined);

    const unsub = realtime.subscribe<Notification>('notifications', (msg) => add(msg.payload));
    return () => unsub();
  }, [isAuthenticated, setItems, add]);

  return <>{children}</>;
}
